import { getOSM, getBattleStateMachine, getBattleGUI } from './OverworldAnimation.js';
import { updateKeyHighlights } from './setup.js';
import { FRAME_DURATION } from './constants.js';
import { keys } from './setup.js';
import { pollGamepad } from './GamepadManager.js';

// Debounce Mechanism
let transientSDetector1 = false;
let transientWDetector1 = false;
let transientADetector1 = false;
let transientDDetector1 = false;
let transientKDetector1 = false;
let transientLDetector1 = false;
let transientPDetector1 = false;
let transientSpaceDetector1 = false;
let transientEnterDetector1 = false;

let transientSDetector2 = false;
let transientWDetector2 = false;
let transientADetector2 = false;
let transientDDetector2 = false;
let transientKDetector2 = false;
let transientLDetector2 = false;
let transientPDetector2 = false;
let transientSpaceDetector2 = false;
let transientEnterDetector2 = false;

export let keySPressInstant = false;
export let keyWPressInstant = false;
export let keyAPressInstant = false;
export let keyDPressInstant = false;
export let keyKPressInstant = false;
export let keyLPressInstant = false;
export let keyPPressInstant = false;
export let keySpacePressInstant = false;
export let keyEnterPressInstant = false;

let lastFrameTime = 0;
export function battleAnimationLoop(currentTime) {
    const osm = getOSM();
    window.requestAnimationFrame(battleAnimationLoop);
    if (!osm?.isInBattle()) {
        return;
    }
    updateKeyHighlights();
    const now = currentTime ?? performance.now();
    const deltaTime = now - lastFrameTime;
    // console.log(deltaTime);

    if (deltaTime < FRAME_DURATION) {
        return;
    }

    pollGamepad();

    transientSDetector1 = keys.s.pressed || keys.S.pressed;
    transientWDetector1 = keys.w.pressed || keys.W.pressed;
    transientADetector1 = keys.a.pressed || keys.A.pressed;
    transientDDetector1 = keys.d.pressed || keys.D.pressed;
    transientKDetector1 = keys.k.pressed || keys.K.pressed;
    transientLDetector1 = keys.l.pressed || keys.L.pressed;
    transientPDetector1 = keys.p.pressed || keys.P.pressed;
    transientSpaceDetector1 = keys.space.pressed;
    transientEnterDetector1 = keys.enter.pressed;

    keySPressInstant = transientSDetector1 ^ transientSDetector2 && transientSDetector1;
    keyWPressInstant = transientWDetector1 ^ transientWDetector2 && transientWDetector1;
    keyAPressInstant = transientADetector1 ^ transientADetector2 && transientADetector1;
    keyDPressInstant = transientDDetector1 ^ transientDDetector2 && transientDDetector1;
    keyKPressInstant = transientKDetector1 ^ transientKDetector2 && transientKDetector1;
    keyLPressInstant = transientLDetector1 ^ transientLDetector2 && transientLDetector1;
    keyPPressInstant = transientPDetector1 ^ transientPDetector2 && transientPDetector1;
    keySpacePressInstant = transientSpaceDetector1 ^ transientSpaceDetector2 && transientSpaceDetector1;
    keyEnterPressInstant = transientEnterDetector1 ^ transientEnterDetector2 && transientEnterDetector1;

    const bsm = getBattleStateMachine();
    const battleGUI = getBattleGUI();
    if (bsm) bsm.update();
    if (battleGUI) battleGUI.update();

    transientSDetector2 = transientSDetector1;
    transientWDetector2 = transientWDetector1;
    transientADetector2 = transientADetector1;
    transientDDetector2 = transientDDetector1;
    transientKDetector2 = transientKDetector1;
    transientLDetector2 = transientLDetector1;
    transientPDetector2 = transientPDetector1;
    transientSpaceDetector2 = transientSpaceDetector1;
    transientEnterDetector2 = transientEnterDetector1;

    lastFrameTime = now;
}
